import useAxios from 'axios-hooks';

export const useFetchPdfPreview = (
  reportId: number,
  language: string,
  section: string
) => {
  return useAxios({
    url: `/export-pdf/${reportId}/preview/${section}`,
    params: {
      language: language,
    },
    method: 'GET',
    responseType: 'arraybuffer',
  });
};
